module.exports = "<h1>Project List</h1>"


//////////////////
// WEBPACK FOOTER
// ./src/app/project/project-list/project-list.component.html
// module id = 561
// module chunks = 1